import { render, staticRenderFns } from "./addComplaintList.vue?vue&type=template&id=06769928&scoped=true"
import script from "./addComplaintList.vue?vue&type=script&lang=js"
export * from "./addComplaintList.vue?vue&type=script&lang=js"
import style0 from "./addComplaintList.vue?vue&type=style&index=0&id=06769928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06769928",
  null
  
)

export default component.exports